import { Option } from "../../common/inputs/OptionsPicker";

const FieldPickerValues = ({ options }: { options: Option[] }) => {
    return <div className="field-picker-items">
        {options.length 
            ? options.map((option, index) => (
                <OptionItem key={index} option={option} useComma={index < options.length - 1} />
            ))
            : <>Not selected</>
        }
    </div>
}

const OptionItem = ({option, useComma}: { option: Option, useComma: boolean }) => {
    return <div className="field-picker-item" title={option.text}>
        {!!option.icon && <span className="field-picker-item-icon" style={{backgroundImage: `url(${option.icon})`}}></span>}
        <span>{`${option.text}${useComma ? ',' : ''}`}</span>
    </div>
}


export default FieldPickerValues;